import React, { Component } from "react";
import { Container } from "reactstrap";
import LetterByLetter from "../../components/common/LetterByLetter";
import ServicesList from "../../components/common/ServicesList";
import VehiclesTypes from "../../components/Vehicles/Vehicles";
import QuoteEmbed from "../landing-v2/QuoteEmbed";
import "../landing-v2/landing-v2.css";

function headingHasTrustRow(heading) {
  if (!heading || !heading.props) return false;
  const walk = (node) => {
    if (!node || typeof node !== "object") return false;
    if (
      typeof node.props?.className === "string" &&
      node.props.className.includes("headline-trust-row")
    ) {
      return true;
    }
    return React.Children.toArray(node.props?.children).some(walk);
  };
  return walk(heading);
}

/**
 * Shared booking shell for service hub pages (/bakkie-hire, /customer-truck-hire, …).
 * Keeps page-specific SEO copy; the calculator is always v2 QuoteWidget.
 */
class Section extends Component {
  render() {
    const { seo, heading, description, services, rows } = this.props;
    const showTrust = !headingHasTrustRow(heading);

    return (
      <>
        {seo}
        <section className="hero-section" id="pagetop">
          <div className="lp2 lp2-hub-intro">
            <Container>
              <div className="lp2-hub-intro-head">
                <div className="lp2-hub-intro-heading">
                  {heading || (
                    <h2 className="main-headline">
                      <LetterByLetter />
                      <br />
                      <VehiclesTypes />
                    </h2>
                  )}
                  {description && (
                    <p className="lp2-hub-description">{description}</p>
                  )}
                </div>
                {showTrust && (
                  <div className="lp2-hub-trust">
                    <span>
                      <i className="mdi mdi-star" /> 4.7 rated
                    </span>
                    <span>
                      <i className="mdi mdi-shield-check" /> Insured
                    </span>
                    <span>
                      <i className="mdi mdi-clock-fast" /> Same-day
                    </span>
                    <span>
                      <i className="mdi mdi-account-check" /> Vetted drivers
                    </span>
                  </div>
                )}
              </div>

              <div className="lp2-hub-services">
                {services || <ServicesList />}
              </div>
            </Container>
          </div>

          <QuoteEmbed />

          {rows && <Container className="lp2-hub-rows">{rows}</Container>}
        </section>
      </>
    );
  }
}

export default Section;
